export default __webpack_public_path__ + "static/media/basic-website.e6ea2903.png";